import { CompanyFeed } from '@/components/CompanyFeed';
import { SubSubSectionHeader } from '@/components/CompanyOverview/components/SubSubSectionHeader';
import { useMobileDetect } from '@/hooks/useMobileDetect';
import { useTheme } from '@simplywallst/ui-core';
import Media from 'react-media';
import { LATEST_NEWS_AND_UPDATES_ANCHOR } from '../../../../constants/anchors';
import PageAnchor from '../../../PageAnchor';
import { MoreUpdates } from './components/MoreUpdates';

interface Props {
  lookupValue: string;
}
export function RecentUpdates(props: Props) {
  const theme = useTheme();
  const isMobile = useMobileDetect();
  return (
    <>
      <PageAnchor
        type="sub-section-title"
        id={LATEST_NEWS_AND_UPDATES_ANCHOR}
      />
      <SubSubSectionHeader>{`Recent News & Updates`}</SubSubSectionHeader>
      <Media query={{ maxWidth: theme.mdMaxRaw }} defaultMatches={isMobile}>
        {(match) => {
          return (
            <>
              <CompanyFeed
                lookup={props.lookupValue}
                limit={6}
                containerSize={match ? 'sm' : 'lg'}
                showAllEvents
                isCompanyReport
              />
              <MoreUpdates lookup={props.lookupValue} />
            </>
          );
        }}
      </Media>
    </>
  );
}
